<template>
    <div class="wrapper">
      <DataTable :value="orderHistory" rowGroupMode="rowspan" groupRowsBy="date" sortMode="single">
        <Column field="date" header="Datum" headerStyle="width: 16em">
          <template #body="slotProps">
            {{formatDate(slotProps.data.date)}}
          </template>
        </Column>
        <Column field="name" header="Namn" headerStyle="width: 16em"></Column>
        <Column field="value" header="Nytt värde"></Column>
        <Column field="oldvalue" header="Tidigare värde"></Column>
      </DataTable>
    </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import moment from 'moment'
export default {
  components: {
    DataTable,
    Column
  },
  props: {
    orderHistory: Array,
    schema: {}
  },
  methods: {
    formatDate (theDate) {
      return moment(theDate).format('YYYY-MM-DD HH:MM')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/OrderHistory.vue